// Initialize Newsletter
var newsletterInfo = $.ajax({
    url: ajaxUrls.newsletter.Info,
    type: 'GET',
    dataType: 'json',
    contentType: 'application/json; charset=utf-8'
});

(function () {
    var visibleHeader = $('div.container > header').length > 0 ? $('div.container > header') : $('div.container > div.header');

    var newsletterModel = new NewsletterModel();

    newsletterInfo.done(function (info) {
        newsletterModel.Email(info.Email);
        newsletterModel.UserHasNewsletter(info.UserHasNewsletter);
    }).fail(function (err) {
        if (err && err.Message) console.error("shop.common.js - Newsletter/Info - Exception: " + err.Message + "\n " + err.StackTrace);
        alerts.error();
    });
    if (visibleHeader.length > 0 && visibleHeader.find("#newsletter").length > 0) {
        ko.applyBindings(newsletterModel, visibleHeader.find('#newsletter')[0]);
    }

    $("#btnCancelNewsletter").click(function () {
        $("#newsletter .formcontent").html("");
    });

    $("*#btnAddNewsletter").click(function () {
        var data = ko.mapping.toJSON(newsletterModel);
        newsletterModel.Loading(true);
        $.ajax({
            url: ajaxUrls.newsletter.AddUserToNewsletter,
            type: 'POST',
            data: data,
            dataType: 'json',
            contentType: 'application/json; charset=utf-8'
        }).done(function (returnArr) {
            newsletterModel.Errors.removeAll();
            if (!returnArr.Success) {
                $.each(returnArr.Errors, function (index, item) {
                    newsletterModel.Errors.push(item);
                });
            } else {
                newsletterModel.Saved(true);
                // redirect to confirmation page
                window.location.pathname = ajaxUrls.newsletter.Confirmation;
            }
        }).fail(function () {
            alerts.error();
        }).always(function () {
            newsletterModel.Loading(false);
        });
    });
})();